export default __webpack_public_path__ + "static/media/unlik.421ce06d.svg";